<!-- A day and a time as dd.mm.yyyy hh:mm, 24-hour, in every browser (see
     ./dates.js for why not the browser's datetime-local field). Typed, or the
     day picked from Vuetify's Estonian calendar, which keeps the time.

     The value is 'YYYY-MM-DDTHH:mm' both ways, as the native field's was.
     Something typed that does not read goes back to the last good value on
     blur. Every attribute and the append-inner slot pass through to the
     Vuetify text field. -->
<template>
  <v-text-field
    :model-value="draft"
    :disabled="disabled"
    placeholder="pp.kk.aaaa tt:mm"
    autocomplete="off"
    v-bind="$attrs"
    @update:model-value="draft = $event || ''"
    @blur="commit"
    @keydown.enter.prevent="commit"
  >
    <template #append-inner>
      <slot name="append-inner" />
      <v-menu v-model="open" :close-on-content-click="false" location="bottom end" min-width="290">
        <template #activator="{ props: menu }">
          <v-icon v-bind="menu" aria-label="Vali kalendrist" role="button" tabindex="-1">mdi-calendar</v-icon>
        </template>
        <v-date-picker
          :model-value="pickerDate"
          color="primary"
          show-adjacent-months
          hide-header
          @update:model-value="pick"
        />
      </v-menu>
    </template>
  </v-text-field>
</template>

<script>
import dayjs from 'dayjs'
import { parseDateTime, showDateTime } from './dates'

export default {
  inheritAttrs: false,
  props: {
    modelValue: { type: String, default: '' },
    disabled: { type: Boolean, default: undefined }
  },
  emits: ['update:modelValue'],
  data () {
    return { draft: showDateTime(this.modelValue), open: false }
  },
  computed: {
    pickerDate () {
      return this.modelValue ? dayjs(this.modelValue).toDate() : undefined
    }
  },
  watch: {
    modelValue (value) {
      this.draft = showDateTime(value)
    }
  },
  methods: {
    commit () {
      const value = parseDateTime(this.draft, this.modelValue)
      if (value && value !== this.modelValue) this.$emit('update:modelValue', value)
      this.draft = showDateTime(value || this.modelValue)
    },
    pick (date) {
      this.open = false
      if (!date) return
      const time = this.modelValue ? dayjs(this.modelValue).format('HH:mm') : '08:00'
      this.$emit('update:modelValue', dayjs(date).format('YYYY-MM-DD') + 'T' + time)
    }
  }
}
</script>
